import { Tabs } from 'components/ideal-core-ui'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { Deals } from './Deals'
import { Proposals } from './Proposals'
import { Checklists } from './Checklists'
import { CompanyNotes } from './CompanyNotes'
import { CompanySpend } from './CompanySpend'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import s from './CompanyTabs.scss'
import { TasksContainer } from './TasksContainer'

const selectDeals = createSelector([state => state.company], company => {
  return company.companyActiveDeals
})

const selectLostDeals = createSelector([state => state.company], company => {
  return company.companyLostDeals
})

const selectClosedDeals = createSelector([state => state.company], company => {
  return company.companyClosedDeals
})

const selectProjectDeals = createSelector([state => state.company], company => {
  return company.companyProjectDeals
})

const selectWonDeals = createSelector([state => state.company], company => {
  return company.companyWonDeals
})

const selectProposals = createSelector([state => state.company], company => {
  return company.companyActiveProposals || []
})

const selectWonProposals = createSelector([state => state.company], company => {
  return company.companyWonProposals || []
})

const selectLostProposals = createSelector([state => state.company], company => {
  return company.companyLostProposals || []
})

const CompanyTabs = ({ companyId, companyName }) => {
  const deals = useSelector(state => selectDeals(state.company))
  const lostDeals = useSelector(state => selectLostDeals(state.company))
  const closedDeals = useSelector(state => selectClosedDeals(state.company))
  const projectDeals = useSelector(state => selectProjectDeals(state.company))
  const wonDeals = useSelector(state => selectWonDeals(state.company))
  const proposals = useSelector(state => selectProposals(state.company))
  const wonProposals = useSelector(state => selectWonProposals(state.company))
  const lostProposals = useSelector(state => selectLostProposals(state.company))

  const location = useLocation()
  const { tab } = queryString.parse(location.search)

  return (
    <Tabs
      withUpdateUrl
      className={s.main}
      activeTabKey={tab || 'deals'}
      noPadding
      tabs={[
        {
          key: 'deals',
          label: 'Company Opportunities',
          value: (
            <Deals
              deals={deals}
              lostDeals={lostDeals}
              closedDeals={closedDeals}
              wonDeals={wonDeals}
              projectDeals={projectDeals}
            />
          )
        },
        {
          key: 'proposals',
          label: 'Company Proposals',
          value: (
            <Proposals
              proposals={proposals}
              wonProposals={wonProposals}
              lostProposals={lostProposals}
            />
          )
        },
        {
          label: 'Tasks',
          key: 'tasks',
          value: <TasksContainer companyName={companyName} />
        },
        {
          key: 'checklists',
          label: 'Checklists',
          value: <Checklists />
        },
        {
          key: 'notes',
          label: 'Notes',
          value: <CompanyNotes companyId={companyId} companyName={companyName} />
        },
        {
          key: 'spend',
          label: 'Spend',
          value: <CompanySpend id={companyId} />
        }
      ]}
    />
  )
}

export default CompanyTabs
